import { SECTION_NAMES } from '@/config/widget';
import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const SECTION = derivedThemeValues(_ref => {
  let {
    theme
  } = _ref;
  return {
    [SECTION_NAMES.receipt]: {
      item: {
        color: theme.color.mutedFont,
        divider: {
          color: theme.color.border
        }
      },
      divider: {
        color: theme.color.border
      }
    },
    [SECTION_NAMES.overview]: {
      item: {
        borderColor: theme.color.border,
        heading: {
          fontColor: theme.color.bodyFont
        }
      }
    },
    [SECTION_NAMES.list]: {
      item: {
        text: {
          color: theme.color.bodyFont
        },
        label: {
          color: theme.color.bodyFont
        }
      }
    },
    [SECTION_NAMES.table]: {
      borderColor: theme.color.borderMuted,
      header: {
        backgroundColor: theme.color.bodyBackground,
        color: theme.color.bodyFont
      },
      column: {
        fontColor: theme.color.bodyFont
      }
    }
  };
});